import { render, staticRenderFns } from "./InterniKarta.vue?vue&type=template&id=8174655c&"
import script from "./InterniKarta.vue?vue&type=script&lang=ts&"
export * from "./InterniKarta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports